export default "__VITE_ASSET__DgftT7Ju__"